import React, { useMemo } from 'react';
import { useUserSettingsContext } from 'users/utils/contexts/UserSettingsContext';
import AssetsTable from '../../../Assets/components/AssetsTable';
import * as tableHelpers from '../../../Assets/helpers/assetsTableHelper';
import { useCurrencyContext } from 'app/contexts/Currency/CurrencyContext';

const AssetsPanelTable = ({
  data,
  selectedColumns,
  isK8S,
  costTypes = [],
  usersStore,
  overrideCurrency = null,
  currentOverrideCurrency,
  granularity,
}) => {
  const currencyContext = useCurrencyContext();
  overrideCurrency = currencyContext?.currenciesMap?.[currentOverrideCurrency]?.code ?? overrideCurrency;

  const { getCurrencyNumber } = useUserSettingsContext();
  const columns = useMemo(
    () =>
      tableHelpers.prepareTableColumns(
        selectedColumns,
        isK8S,
        costTypes,
        usersStore.currDispUserCloudAccountType,
        getCurrencyNumber,
        overrideCurrency,
      ),
    [selectedColumns, isK8S, costTypes, usersStore.currDispUserCloudAccountType, getCurrencyNumber, overrideCurrency],
  );

  return (
    <AssetsTable
      usersStore={usersStore}
      data={data}
      columns={columns}
      columnsWidths={tableHelpers.prepareTableColumnsWidths(columns)}
      costColumnsArray={tableHelpers.prepareTableCostColumns(costTypes || [])}
      currenciesColumns={[]}
      tableColumnExtensions={[]}
      granularity={granularity}
      overrideCurrency={overrideCurrency}
    />
  );
};

export default AssetsPanelTable;
